<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { Loader } from '@/components/app'
import { useOrganisationLicenceTypesQuery } from '@/composable/queries/Dara/organisationLicenceTypes'

const authStore = useAuthStore()

const {
  selected_organisation_id,
  canBuyLicences,
} = storeToRefs(authStore)

const {
  data: organisationLicenceTypeData,
  isPending,
  isError,
  error,
} = useOrganisationLicenceTypesQuery(computed(() => selected_organisation_id.value || 0), computed(() => !!selected_organisation_id.value))
</script>

<template>
  <VCard class="elevation-5 flex-grow-1">
    <div
      v-if="isPending"
      class="d-flex"
    >
      <Loader />
    </div>
    <div v-else-if="isError">
      <VAlert type="error">
        {{ error }}
      </VAlert>
    </div>
    <VRow
      v-else-if="organisationLicenceTypeData?.data"
      no-gutters
      class="h-100"
    >
      <VCol
        cols="12"
        class="pa-4 d-flex flex-column"
      >
        <h4 class="mb-2">
          {{ $t('pages.dashboard.available_licences_card_header') }}
        </h4>
        <VTable
          density="compact"
          class="pb-2"
        >
          <thead>
            <tr>
              <th class="licence-header bg-grey-100">
                <span>{{ $t('pages.dashboard.licence_card_type_column') }}</span>
              </th>
              <th class="licence-header text-center bg-grey-100">
                <span>{{ $t('pages.dashboard.licence_card_available_column') }}</span>
              </th>
              <th class="licence-header bg-grey-100" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="licenceType in organisationLicenceTypeData.data"
              :key="licenceType.id"
            >
              <td class="licence-row py-1">
                {{ licenceType.long_name }}
              </td>
              <td class="licence-row text-center">
                {{ licenceType.unused_licences_count }}
              </td>
              <td class="d-flex align-center ga-2">
                <VBtn
                  :to="{ name: 'students.overview' }"
                  :disabled="!licenceType.unused_licences_count"
                  rounded="xl"
                  variant="tonal"
                  size="small"
                  class="submit-blue-btn flex-1-1-0"
                >
                  {{ $t('pages.dashboard.assign_btn') }}
                </VBtn>
                <VBtn
                  v-if="canBuyLicences"
                  :to="{ name: 'licences.overview' }"
                  rounded="xl"
                  variant="tonal"
                  size="small"
                  class="submit-grey-btn flex-1-1-0"
                >
                  {{ $t('pages.dashboard.buy_btn') }}
                </VBtn>
              </td>
            </tr>
          </tbody>
        </VTable>
      </VCol>
    </VRow>
  </VCard>
</template>

<style lang="scss" scoped>
.licence-header {
  height: 1.8rem !important;
  span {
    color: rgb(var(--v-theme-on-surface));
  }
}
.licence-row {
  font-size: .8rem;
  height: auto !important;
}
</style>
